import { FunctionComponent, memo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { getInteractionIcon } from "./interaction-icon.utilities";
import { IProps } from "./interaction-icon.types";
import "./interaction-icon.scss";

/**
 * Render an icon relevant to the interaction type passed.
 * @param props.interactionType
 * @returns An icon relevant to the interaction type.
 */
const InteractionIcon: FunctionComponent<IProps> = ({ interactionType }) => (
    <div className="interaction-icon">
        <FontAwesomeIcon icon={getInteractionIcon(interactionType)} />
    </div>
);

export default memo(InteractionIcon);
